import { ITiendaProductos } from "@/types/app";
import ProductGrid from "../products/productGrid";

const Product = ({ data }: { data: ITiendaProductos }) => {
    return <ProductGrid data={data} />;
};

export default Product;
